import { Group, Stack, Text } from '@mantine/core';

type TenantHeadlineProps = {
  value: number;
  label: string;
  color: string;
  icon: React.ReactNode;
};

export const TenantHeadline = ({ value, label, color, icon }: TenantHeadlineProps) => (
  <Group gap={10} wrap="nowrap">
    {icon}
    <Stack gap={1}>
      <Text ff="heading" fz={26} fw={600} lh={1} c={color}>
        {value}
      </Text>
      <Text fz={11} c="gray.6">
        {label}
      </Text>
    </Stack>
  </Group>
);
